import { assignInlineVars } from '@vanilla-extract/dynamic';

export const jsonAssignInlineVars = (value: any) => {
  return JSON.parse(JSON.stringify(assignInlineVars(value)));
};
